import { z } from 'zod';

export const bankPreferenceSchema = z.enum(['primary', 'secondary']);
export type BankPreference = z.infer<typeof bankPreferenceSchema>;
